import http from '@/plugins/axios'

export default {
  filesFast: data => http.post('/storage/api/v1/files/fast', data),
  filesUpload: data => http.post('/storage/api/v1/files', data),
  filesTusUpload: data => http.post('/storage/api/v1/tus/upload/', data),
  getStorageTusComplete: data => http.post('/storage/api/v1/tus/completed', data),
}
